export interface AiExperienceSample {
  id: string;
  src: string;
  presetResultSrc: string;
  alt: string;
}

export const AI_EXPERIENCE_SAMPLES = [
  {
    id: 'vton-1',
    src: '/commerce/static/intro/vton/vton_1_1.webp',
    presetResultSrc: '/commerce/static/intro/vton/vton_1_2.webp',
    alt: 'Sample image 1',
  },
  {
    id: 'vton-2',
    src: '/commerce/static/intro/vton/vton_2_1.webp',
    presetResultSrc: '/commerce/static/intro/vton/vton_2_2.webp',
    alt: 'Sample image 2',
  },
  {
    id: 'vton-3',
    src: '/commerce/static/intro/vton/vton_3_1.webp',
    presetResultSrc: '/commerce/static/intro/vton/vton_3_2.webp',
    alt: 'Sample image 3',
  },
  {
    id: 'vton-4',
    src: '/commerce/static/intro/vton/vton_4_1.webp',
    presetResultSrc: '/commerce/static/intro/vton/vton_4_2.webp',
    alt: 'Sample image 4',
  },
] as const satisfies readonly AiExperienceSample[];

export type AiExperienceSampleId = (typeof AI_EXPERIENCE_SAMPLES)[number]['id'];

export const getAiExperienceSample = (
  id: AiExperienceSampleId,
): (typeof AI_EXPERIENCE_SAMPLES)[number] => {
  const sample = AI_EXPERIENCE_SAMPLES.find((item) => item.id === id);
  if (!sample) {
    throw new Error(`Unknown AI experience sample id: ${id}`);
  }
  return sample;
};
